var React = require('react');

function ArrowCaretUp (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Arrow: caret up"),React.createElement("polygon",{"id":"Path","fill":"currentColor","fillRule":"nonzero","points":"1.01615575 7.56237386 0 6.46153846 7 0 14 6.46153846 12.9838442 7.56237386 7 2.03882533","key":1})]);
}

ArrowCaretUp.defaultProps = {"viewBox":"0 0 14 8","version":"1.1"};

module.exports = ArrowCaretUp;

ArrowCaretUp.default = ArrowCaretUp;
